import { createContext, useContext } from 'react';
export var SwiperSlideContext = /*#__PURE__*/createContext(null);
export var useSwiperSlide = () => {
  return useContext(SwiperSlideContext);
};
export var SwiperContext = /*#__PURE__*/createContext(null);
export var useSwiper = () => {
  return useContext(SwiperContext);
};